module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_2048.83ad9386.jpg";